import React,{ useRef, useEffect } from "react";
import Compass from "@arcgis/core/widgets/Compass.js";

const CompassWidget = ({view}) => {
    
    const compassWidgetDiv = useRef(null);
    
    useEffect(()=> {
        if(compassWidgetDiv.current){
            const compassWidget = new Compass({
                container: compassWidgetDiv.current,
                view: view
            }) 
            view.ui.add(compassWidget,"top-left")
            
            return ()=> {
                compassWidget.destroy()
            }
        }
    },[])
    
    return(
    <div ref={compassWidgetDiv}></div>
    )   
}

export default CompassWidget